import { render, staticRenderFns } from "./SubscriptionPlanEdit.vue?vue&type=template&id=2bf93e9d&"
import script from "./SubscriptionPlanEdit.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPlanEdit.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionPlanEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports